import { useEffect, useState } from "react";

function pad(n: number) {
  return String(n).padStart(2, "0");
}

export function DisplayClock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <time
      dateTime={now.toISOString()}
      className="shrink-0 font-bold text-2xl tabular-nums tracking-tight md:text-4xl"
    >
      {pad(now.getHours())}:{pad(now.getMinutes())}
      <span className="text-neutral-500">:{pad(now.getSeconds())}</span>
    </time>
  );
}
